import type { getNotificationsAction, notificationWasShownAction } from "~/actions/notifications";
import type { CommentType } from "~/common/constants";
import type { DateString } from "~/types/common";
import type { TUser } from "~/types/user";

export function notificationWasShown(
  state = true,
  action: ReturnType<typeof notificationWasShownAction>,
): boolean {
  switch (action.type) {
    case "NOTIFICATIONS_WAS_SHOWN":
      return action.notificationWasShown;

    default:
      return state;
  }
}

export type TComment = {
  viewer_plan?: { id: number; correction_index: number; version: number } | null;
  account_id: TUser["account_id"];
  comment: string;
  commenter: {
    external: boolean;
    first_name: string;
    full_name: string;
    last_name: string;
    avatar: string | null;
  };
  timestamp: DateString;
  type: CommentType;
};

type CommentsState = TComment[] | Record<string, unknown>;

type CommentsAction =
  | { type: "GET_PATIENT_COMMENTS"; json: TComment[] }
  | { type: "POST_PATIENT_COMMENTS"; json: TComment[] }
  | { type: "ERASE_COMMENTS" };

export function comments(state: CommentsState = {}, action: CommentsAction): CommentsState {
  switch (action.type) {
    case "GET_PATIENT_COMMENTS":
      return action.json;

    case "POST_PATIENT_COMMENTS":
      return action.json;

    case "ERASE_COMMENTS":
      return {};

    default:
      return state;
  }
}

export type TNotification = TPaymentNotification;

type TPaymentNotification = {
  id: number;
  type: "waiting_for_payment";
  additional_data: {
    patient_id: number;
  };
};

export function notifications(
  state: TNotification[] = [],
  action: ReturnType<typeof getNotificationsAction>,
): TNotification[] {
  switch (action.type) {
    case "GET_NOTIFICATIONS":
      return action.notifications;

    default:
      return state;
  }
}
